// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".video-player-MpegPlayer-king-container[data-v-5fc68116]{min-height:169px;min-width:300px;width:100%;height:100%;background:#000;position:relative}.MpegPlayer-style[data-v-5fc68116]{width:100%!important;height:100%!important}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
